import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import { memo } from "react";
import Icon from "@/components/ui/Icon";

type ArrowLinkProps = {} & React.ComponentProps<"a"> & LinkProps;

const ArrowLink: React.FC<ArrowLinkProps> = ({
  href,
  className,
  children,
  ...rest
}) => {
  return (
    <Link
      href={href}
      className={cn(
        "inline-flex leading-[150%] font-semibold gap-2 text-blue md:text-sm md:leading-[150%] cursor-pointer"
      )}
      {...rest}
    >
      <span>{children}</span>
      <Icon
        id="icon-arrow-right_24"
        width={24}
        height={24}
        className="shrink-0 w-6 h-6"
      />
    </Link>
  );
};

export default memo(ArrowLink);
